export * from './kommunikation-badge.component';
export * from './kommunikation-badge.component.module';